import type { FaireProductEntity } from "../../entity_types/product";

export const p_vu44yvfxdb: FaireProductEntity = {
  token: "p_vu44yvfxdb",
  type: "product",
  name: "Peanuts x Parks Project Adventure Awaits Youth Hoodie",
  brandToken: "b_1xd9ogml",
  brandName: "Parks Project",
  imageUrl:
    "https://cdn.faire.com/fastly/9d2cf4d9b22dd2e5f01157f93f387813eb8838b687ba9b439ef91916bfb8de38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31431f4efeaa4d59af462cb878df9dfc8efaecbfbd7c8aa67aecfd70bc00496c.jpeg",
    "https://cdn.faire.com/fastly/c9d436d364dc3386da2fce8173b082366f642dea05f4826020c2bcec0c86ee03.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Meet our first youth hoodie! Peanuts meets our best-selling hoodie design, now available in youth sizing, and the same adventure-inspired design.\n\nMaterials:\n\n * 80% cotton // 20% polyester\n \nCare: \n\n * Machine wash cold with like colors, do not bleach. Do not dry clean. \n * Tumble dry gentle low heat or line dry, cool iron as needed. ",
  tags: [],
  msrpDollars: 55,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:56.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
